import type { FC, MouseEvent } from 'react';
import React, { useCallback } from 'react';
import type { ButtonProps } from './Button';
import { Button } from './Button';
import { useWalletModal } from '../../services/solana/useWalletModal';

const buttonStyles =
  "bg-blue-500 rounded-md pl-3 pr-3 pt-1 pb-1 shadow-lg hover:bg-blue-400 mb-2 font3-bold";

export const SolModalButton: FC<ButtonProps> = ({ children = 'Connect', onClick, ...props }) => {
    const { visible, setVisible } = useWalletModal();

    const handleClick = useCallback(
        (event: MouseEvent<HTMLButtonElement>) => {
            if (onClick) onClick(event);
            // if (!event.defaultPrevented) 
            setVisible(!visible);
        },
        [onClick, setVisible, visible]
    );

    //className="wallet-adapter-button-trigger"

    return (
        <button className={buttonStyles} onClick={handleClick} {...props}>
            {children}
        </button>
        // <Button className="wallet-adapter-button-trigger" onClick={handleClick} {...props}>
        //     {children}
        // </Button>
    );
};
